import React  from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Faq from '../../components/Faq';

import authorImg1 from '../../assets/images/course-single/user4.jpg'
import authorImg2 from '../../assets/images/course-single/user5.jpg'

const CourseDetailsMain = (props) => {
    let 
        tab1 = "Reviews",
        tab2 = "FAQ"
        const tabStyle = 'nav nav-tabs';

   
    
    return (
        <div className="back__course__page_grid react-courses__single-page pb---16 pt---110">
            <div className="container pb---70">
                <div className="row">
                    <div className="col-lg-8">
                        
                        <Tabs>
                            <div className="course-single-tab">
                                <TabList className={tabStyle}>
                                    <Tab><button>{tab1}</button></Tab>
                                    <Tab><button>{tab2}</button></Tab>
                                </TabList>
                                
                                <div className="tab-content" id="back-tab-content">
                                    
                                    
                                    <TabPanel>
                                        <div className="tab-pane">
                                            <h3>Reviews</h3>                                            
                                            <div className="row mt---40 mb----40">
                                                <div className="col-lg-4">
                                                    <div className="five__number">
                                                        <em>4.5</em>
                                                        <div className="back-ratings"> 
                                                            <i className="icon_star"></i>
                                                            <i className="icon_star"></i>
                                                            <i className="icon_star"></i>
                                                            <i className="icon_star"></i>
                                                            <i className="icon_star"></i>
                                                        </div>
                                                        <h6>(4 Ratings)</h6>
                                                    </div>
                                                </div>
                                                <div className="col-lg-8">
                                                    <div className="back-progress-bar">
                                                        <div className="skillbar-style2">
                                                            <div className="skill_inners">
                                                                <span className="skillbar-title">5 stars</span>
                                                                <div className="skillbars green-dark-bg" data-percent="100">               
                                                                    <p className="skillbar-bar"  style={{ width: '100%'}}></p> 
                                                                </div>
                                                                <span>2</span>                                                                
                                                            </div>
                                                            <div className="skill_inners">
                                                                <span className="skillbar-title">4 stars</span>
                                                                <div className="skillbars green-dark-bg" data-percent="50">               
                                                                    <p className="skillbar-bar" style={{ width: '50%'}}></p> 
                                                                </div>
                                                                <span>1</span>                                                                
                                                            </div>
                                                            <div className="skill_inners">
                                                                <span className="skillbar-title">3 stars</span>
                                                                <div className="skillbars green-dark-bg" data-percent="30">               
                                                                    <p className="skillbar-bar" style={{ width: '30%'}}></p> 
                                                                </div>
                                                                <span>1</span>                                                                
                                                            </div>
                                                            <div className="skill_inners">
                                                                <span className="skillbar-title">2 stars</span>
                                                                <div className="skillbars green-dark-bg" data-percent="10">               
                                                                    <p className="skillbar-bar" style={{ width: '10%'}}></p> 
                                                                </div>
                                                                <span>0</span>                                                                
                                                            </div>
                                                            <div className="skill_inners">
                                                                <span className="skillbar-title">1 stars</span>
                                                                <div className="skillbars green-dark-bg" data-percent="0">               
                                                                    <p className="skillbar-bar" style={{ width: '0'}}></p> 
                                                                </div>
                                                                <span>0</span>                                                                
                                                            </div>
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>
                                            <Link to="#" className="post-author">
                                                <div className="avatar">
                                                    <img src={authorImg1} alt="user" /> 
                                                </div>
                                                <div className="info">
                                                    <div className="back-ratings"> 
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                    </div>
                                                    <h4 className="name">Nebin Reji <span className="designation">July 8, 2022 at 7:38 am</span></h4>
                                                    <p>This assessment helped me discover my strongest intelligences and choose a better learning path. The report was clear, practical, and very useful for career planning.</p>          
                                                </div>
                                            </Link>

                                            <Link to="#" className="post-author">
                                                <div className="avatar">
                                                    <img src={authorImg2} alt="user" /> 
                                                </div>
                                                <div className="info"> 
                                                    <div className="back-ratings"> 
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                        <i className="icon_star"></i>
                                                    </div>                                                                                 
                                                    <h4 className="name">Ashin  <span className="designation">July 9, 2022 at 6:20 am</span></h4>
                                                    <p>The intelligence breakdown was accurate and the recommendations matched my interests. I used the results to pick courses that fit my strengths.</p>
                                                </div>
                                            </Link>
                                            <div className="blog-form pt---30">
                                                <h3>Write a Review</h3>
                                                <p className="pb---15">Your email address will not be published. Required fields are marked *</p>
                                                <form id="contact-form">             
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="back-input">
                                                                <input id="name" type="text" name="name" placeholder="Name" />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 pdl-5">
                                                            <div className="back-input">
                                                                <input id="email" type="email" name="email" placeholder="Email" />                                  
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-lg-12">
                                                            <div className="back-input">
                                                                <input id="subject" type="text" name="subject" placeholder="Subject" />                                  
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-12">
                                                            <div className="back-ratings"> <b>Ratings:</b> 
                                                                <i className="icon_star"></i>
                                                                <i className="icon_star"></i>
                                                                <i className="icon_star"></i>
                                                                <i className="icon_star"></i>
                                                                <i className="icon_star"></i>
                                                            </div>
                                                            <div className="back-textarea">
                                                                <textarea id="message" name="message" placeholder="Message"></textarea>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-12">         
                                                            <button type="submit" className="back-btn">Submit Review <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button>
                                                        </div>
                                                    </div>                                                    
                                                </form>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className="tab-pane">
                                            <h3>FAQ</h3>
                                            <Faq />
                                        </div>
                                    </TabPanel>
                                </div>
                            </div>
                        </Tabs>
                        
                    </div>
                    
                </div>
            </div>
        </div> 
    );
}

export default CourseDetailsMain;